import { TRANSACTION_ACTION_TYPES } from '../actions/types';

const initialState = {
  lookupUser: {
    data: null,
    loading: false,
    error: null,
  },
  listServices: {
    data: null,
    loading: false,
    error: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TRANSACTION_ACTION_TYPES.LOOKUP_USER_REQUEST:
      return {
        ...state,
        lookupUser: {
          ...state.lookupUser,
          loading: true,
          error: null,
        },
      };

    case TRANSACTION_ACTION_TYPES.LOOKUP_USER_SUCCESS:
      return {
        ...state,
        lookupUser: {
          data: action.payload.data,
          loading: false,
          error: null,
        },
      };

    case TRANSACTION_ACTION_TYPES.LOOKUP_USER_FAILURE:
      return {
        ...state,
        lookupUser: {
          ...state.lookupUser,
          loading: false,
          error: action.payload.error,
        },
      };

    case TRANSACTION_ACTION_TYPES.LIST_SERVICES_REQUEST:
      return {
        ...state,
        listServices: {
          ...state.listServices,
          loading: true,
          error: null,
        },
      };

    case TRANSACTION_ACTION_TYPES.LIST_SERVICES_SUCCESS:
      return {
        ...state,
        listServices: {
          data: action.payload.data,
          loading: false,
          error: null,
        },
      };

    case TRANSACTION_ACTION_TYPES.LIST_SERVICES_FAILURE:
      return {
        ...state,
        listServices: {
          ...state.listServices,
          loading: false,
          error: action.payload.error,
        },
      };

    case TRANSACTION_ACTION_TYPES.CLEAR_TRANSACTION_ERRORS:
      return {
        ...state,
        lookupUser: {
          ...state.lookupUser,
          error: null,
        },
        listServices: {
          ...state.listServices,
          error: null,
        },
      };

    default:
      return state;
  }
};

